'use es6';

export const TEMPLATE = 'TEMPLATE';
export const CONTENT = 'CONTENT';
/* eslint-env commonjs */
// This temporary hack ensures module system compatibility.
// Read more at go/treeshaking

if (!!module && !!module.exports) {
  module.exports.default = Object.assign({}, module.exports);
}